import { PortfolioDTO } from "../DTO/portfolioDTO";

export class StorePortfolioRequest{
    public userId!:string;
    public businessId!:string;
    public portfolio!:PortfolioDTO;
}